import { render } from "./PCVolcadosLinea.vue?vue&type=template&id=545256e4&scoped=true"
import script from "./PCVolcadosLinea.vue?vue&type=script&lang=js"
export * from "./PCVolcadosLinea.vue?vue&type=script&lang=js"

import "./PCVolcadosLinea.vue?vue&type=style&index=0&id=545256e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545256e4"]])

export default __exports__